"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_SeedOfDarkness_OnTargetKilledOrTickEventHandlerScript = void 0;
const AbilityDamage_1 = require("../../core/AbilityDamage");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
let Effect_SeedOfDarkness_OnTargetKilledOrTickEventHandlerScript = class Effect_SeedOfDarkness_OnTargetKilledOrTickEventHandlerScript {
    run(sequence, container, handler, event) {
        container.cancelEffect(sequence, handler.args.scriptArgs.effectId);
        const targets = container.selectLivingTargets(handler.subject, Target_1.Target.AllAllies);
        container.applyProjectiles({
            projectiles: targets.map((targetId) => ({
                jitter: 0,
                type: "GreenMagicBall",
                path: "arc",
                creatorId: handler.subject,
                targetId,
            })),
            sequence,
            onProjectile(sequence, projectile) {
                const onHitSequence = sequence.pushSequence("parallel");
                container.applyAttackDamage({
                    attackType: "magic_tick",
                    attackerId: handler.args.scriptArgs.createdBy,
                    targetId: projectile.targetId,
                    isCrit: false,
                    toApply: AbilityDamage_1.AbilityDamage.Focus("Death", 100),
                    sequence: onHitSequence.pushSequence("sequential")
                });
                container.applyDebuff({
                    attackerId: handler.args.scriptArgs.createdBy,
                    targetId: projectile.targetId,
                    duration: Duration_1.Duration.Turns(2),
                    effect: new core_1.DiseasedEffectArgs("Focus", 10),
                    sequence: onHitSequence.pushSequence("sequential"),
                });
            }
        });
    }
};
Effect_SeedOfDarkness_OnTargetKilledOrTickEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_SeedOfDarkness_OnTargetKilledOrTick")
], Effect_SeedOfDarkness_OnTargetKilledOrTickEventHandlerScript);
exports.Effect_SeedOfDarkness_OnTargetKilledOrTickEventHandlerScript = Effect_SeedOfDarkness_OnTargetKilledOrTickEventHandlerScript;
